import type { SettingsSource } from '../models/settings-hub.model';

import { field } from './settings-builders';
const IP_ADDRESS_PATTERN = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;

export const LOCAL_COMMUNICATION_SUBCATEGORY: SettingsSource = {
    id: 'local-communication',
    cards: [
        {
            id: 'master-devices',
            settings: [
                field.toggle('local_server.enable_android', 'SETTINGS.SETTINGS.LOCAL_SERVER.ENABLE_ANDROID'),
                field.toggle('local_server.enable_electron', 'SETTINGS.SETTINGS.LOCAL_SERVER.ENABLE_ELECTRON'),
                field.toggle('local_server.enable_ios', 'SETTINGS.SETTINGS.LOCAL_SERVER.ENABLE_IOS'),
                field.number('local_server.port', 'SETTINGS.SETTINGS.LOCAL_SERVER.PORT', { min: 1000, defaultValue: 2013 })
            ]
        }
    ]
};

export const SCALES_SUBCATEGORY: SettingsSource = {
    id: 'scales',
    cards: [
        {
            id: 'scales-configuration',
            settings: [
                {
                    id: 'scales.list',
                    preferenceKey: 'scales.list',
                    control: 'object-list',
                    label: 'SETTINGS.SCALES.TITLE',
                    objectList: {
                        addLabel: 'SETTINGS.SCALES.ADD',
                        fields: [
                            { key: 'name', label: 'SETTINGS.SCALES.NAME', control: 'text', required: true },
                            { key: 'type', label: 'SETTINGS.SCALES.TYPE', control: 'select', required: true, options: () => [{ value: 'helmac', label: 'Helmac' }] },
                            { key: 'ip_address', label: 'SETTINGS.SCALES.IP_ADDRESS', control: 'text', required: true, pattern: IP_ADDRESS_PATTERN }
                        ]
                    }
                },
                field.toggle('cashregister.scales.legacy_piece_letters', 'SETTINGS.SCALES.LEGACY_PIECE_LETTERS'),
                field.toggle('cashregister.scales.manage_categories', 'SETTINGS.SCALES.MANAGE_CATEGORIES')
            ]
        }
    ]
};
